import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

import { FormConfirmDialog } from "@/components/FormConfirmDialog";
import { createFollowing } from "@/services/following";

import {
  FollowingEditor,
  useFollowingEditorForm,
} from "../../components/FollowingEditor";

import { getApiErrorMessage, refetchQueries } from "@/utils";

import type { AxiosErrorWithData } from "@/client/api";

export type AddFollowingDialogProps = {
  open: boolean;
  onClose: () => void;
  customerId: string;
  fetchKeys?: string[];
};

export function AddFollowingDialog({
  open: isOpen,
  onClose,
  customerId,
  fetchKeys = [],
}: AddFollowingDialogProps) {
  const { control, handleSubmit, reset } = useFollowingEditorForm();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { mutate: add, isLoading } = useMutation(createFollowing, {
    onSuccess: async () => {
      enqueueSnackbar("เพิ่มการติดตามสำเร็จ", { variant: "success" });
      await refetchQueries({ queryClient, fetchKeys });
      close();
    },
    onError: (error: AxiosErrorWithData) => {
      console.error(error);
      enqueueSnackbar(getApiErrorMessage(error), { variant: "error" });
    },
  });

  function close() {
    onClose();
    reset();
  }

  const onSubmit = handleSubmit((form) => {
    add({
      followAt: form.following.date,
      remark: form.following.remark ?? null,
      customerId,
    });
  });

  const title = "เพิ่มการติดตาม";

  return (
    <FormConfirmDialog
      maxWidth="sm"
      control={control}
      title={title}
      loading={isLoading}
      open={isOpen}
      onClose={close}
      onConfirm={onSubmit}
    >
      <FollowingEditor isSingleForm control={control} />
    </FormConfirmDialog>
  );
}
